/**
 * Farbband der Liegezeit – eine Stelle für alle Ansichten.
 *
 * „Meine Aufgaben" und die Angebotsübersicht zeigen dieselbe Zahl und müssen
 * sie gleich einfärben. Zwei Umsetzungen liefen auseinander: Das Cockpit hatte
 * eigene Schwellen im Code und ein Oliv-Braun, während „Meine Aufgaben" die
 * zentral gepflegten Bänder und Bernstein verwendete. Derselbe Vorgang sah in
 * zwei Masken unterschiedlich dringend aus.
 *
 * Es sind Farben, keine Fristen: Sie sagen, wie lange etwas liegt – nicht,
 * dass jemand etwas versäumt hätte.
 */

/** `ruhig` trägt keine Plakette – nur die beiden Stufen darüber werden gefüllt. */
export type Liegestufe = 'ruhig' | 'bernstein' | 'rot';

/**
 * Ab wann ein Vorgang als kritisch gilt: eine Woche nach der Warnstufe.
 *
 * Abgeleitet und nicht als zweite Einstellung geführt. Verschiebt die
 * Geschäftsführung den Nachfass-Rhythmus, wandern Ring und Liste gemeinsam mit
 * – und es gibt keine zweite Zahl, die man dabei vergessen könnte.
 *
 * Nicht zu verwechseln mit der Einstellung `krit`: Die steuert, wann statt
 * einer Erinnerung ein Anruf fällig wird, und ist eine andere Frage.
 */
export function kritischAb(warnAb: number): number {
  return warnAb + 7;
}

/**
 * Welche Stufe eine Liegezeit trägt.
 *
 * Beide Grenzen einschließlich: 14 Tage sind bereits die Warnstufe, 21 Tage
 * bereits kritisch. Die Beschriftungen nennen dieselben Zahlen („14 bis 20
 * Tage", „über 21 Tage"), und wer 21 liest, soll dieselbe Farbe sehen.
 */
export function liegestufe(tage: number, warnAb: number): Liegestufe {
  if (tage >= kritischAb(warnAb)) return 'rot';
  if (tage >= warnAb) return 'bernstein';
  return 'ruhig';
}
